import { render, staticRenderFns } from "./TaskUsersModal.vue?vue&type=template&id=89dc85ee"
import script from "./TaskUsersModal.vue?vue&type=script&lang=js"
export * from "./TaskUsersModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports